export const VirtualManagerResumeTypes = {
  diario: "diario",
  semanal: "semanal",
  mensal: "mensal",
}